const abbreviateName = (name, maxLength) => {
  if (!name || typeof name !== 'string') {
    return '';
  }

  const nameArray = name.trim().split(/\s+/);
  const prepositions = ['de', 'da', 'dos', 'das', 'e'];

  if (name.length < maxLength) {
    return nameArray
      .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

  const firstName = nameArray[0];
  const lastName = nameArray[nameArray.length - 1];
  const abbreviatedMiddle = nameArray.slice(1, -1).map(word => {
    if (prepositions.includes(word.toLowerCase())) {
      return word;
    } else {
      return `${word.charAt(0).toUpperCase()}.`;
    }
  });

  return [capitalize(firstName), ...abbreviatedMiddle, capitalize(lastName)].join(' ');
};

const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export { abbreviateName };
